import axios from 'axios';
import {tApi} from 'tplus-api';
const QS = require('qs');

export default class LoginApi{
  
  static async getSysInfoForGZQ(){
    const method = 'chanjet.MB.TxBusCommon.GetSysInfoForGZQ';
    const resp = await tApi({},method,false);
    return resp;
  }

  static async getOrderFunction(param){
    const method = 'chanjet.MB.MBPortal.GetPortalByAppid';
    const resp = await tApi(param,method,false);
    return resp;
  }

  static async getAccountInfo(param){
    const method = 'chanjet.SM.AccountOption.GetAccountInfo';
    const resp = await tApi(param,method,false);
    return resp;
  }

  static async getWorkFlow(param){
    const method = 'chanjet.MB.TxBusCommon.IsVoucherNeedWorkFlow';
    const resp = await tApi(param,method,false);
    return resp;
  }
}
